module.exports = __webpack_public_path__ + "NoeDisplay-Bold.88860d7bc02ca6c44f4a.ttf";


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/fonts/NoeDisplay-Bold/NoeDisplay-Bold.ttf
// module id = ../../../../../src/assets/fonts/NoeDisplay-Bold/NoeDisplay-Bold.ttf
// module chunks = styles